import React, {useMemo, useRef} from "react";

import "./index.scss";

const clamp = (value, min, max) => Math.min(Math.max(value, min), max);

const normalizePoints = (points) => {
	if (Array.isArray(points)) {
		return points;
	}
	if (typeof points === "string") {
		try {
			const parsed = JSON.parse(points);
			return Array.isArray(parsed) ? parsed : [];
		} catch (error) {
			return [];
		}
	}
	return [];
};

const ShotTargetMap = ({points, onChange, readOnly = false, className = ""}) => {
	const goalRef = useRef(null);
	const normalizedPoints = useMemo(() => normalizePoints(points), [points]);

	const handleAddPoint = (event) => {
		if (readOnly || !goalRef.current) {
			return;
		}
		const rect = goalRef.current.getBoundingClientRect();
		const x = clamp(((event.clientX - rect.left) / rect.width) * 100, 0, 100);
		const y = clamp(((event.clientY - rect.top) / rect.height) * 100, 0, 100);

		const nextPoints = [
			...normalizedPoints,
			{
				x: Number(x.toFixed(2)),
				y: Number(y.toFixed(2)),
			},
		];

		onChange?.(nextPoints);
	};

	const handleRemovePoint = (index, event) => {
		if (readOnly) {
			return;
		}
		event.stopPropagation();
		const nextPoints = normalizedPoints.filter((_, pointIndex) => pointIndex !== index);
		onChange?.(nextPoints);
	};

	return (
		<div className={`shot-target-map ${className}`}>
			<div
				className={`shot-target-map__goal ${readOnly ? "is-readonly" : ""}`}
				ref={goalRef}
				onClick={handleAddPoint}
				role={readOnly ? "img" : "button"}
				aria-label="Mappa tiri in porta"
				tabIndex={readOnly ? -1 : 0}
			>
				<div className="shot-target-map__net" />
				{normalizedPoints.map((point, index) => (
					<div
						key={`${point.x}-${point.y}-${index}`}
						className="shot-target-map__point"
						style={{left: `${point.x}%`, top: `${point.y}%`}}
						onClick={(event) => handleRemovePoint(index, event)}
					/>
				))}
			</div>
			<div className="shot-target-map__hint">
				{readOnly
					? `Totale tiri in porta: ${normalizedPoints.length}`
					: "Clicca sulla porta per aggiungere un tiro. Clicca un punto per rimuoverlo."}
			</div>
			{normalizedPoints.length === 0 && (
				<div className="shot-target-map__empty">Nessun tiro in porta registrato.</div>
			)}
		</div>
	);
};

export default ShotTargetMap;
